









import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class ColumnHeader extends Vue {
  @Prop() readonly text!: string;
  @Prop() readonly sortColumn?: string;
  @Prop() readonly currentSortColumn?: string;
  @Prop() readonly isAscending?: boolean;
  @Prop() readonly onSort?: (column: string) => void;

  sort() {
    if (!this.sortColumn) return;

    this.onSort?.(this.sortColumn);
  }
}
